export default __webpack_public_path__ + "69429656cc1a3f805e9a026cb0c1ddc2.png";